// extracted by mini-css-extract-plugin
export default {"text-large":"text-large_text-large__jkuny","required":"text-large_required__KjLL7"};